/* BCS v29: when a discount code is on the basket, say so in the free delivery line. Shopify judges free delivery on the total after discounts. */
(function () {
  var timer;
  function apply() {
    var d = document.querySelector('.bcs-cart__header-desc');
    if (!d || d.getAttribute('data-bcs-note') || !/away from free UK delivery/.test(d.textContent)) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var hasDiscount = (c.cart_level_discount_applications || []).length > 0 || c.total_discount > 0;
      if (!hasDiscount || d.getAttribute('data-bcs-note')) return;
      d.innerHTML = d.innerHTML.replace("You're", "With your discount applied, you're");
      d.setAttribute('data-bcs-note', '1');
    }).catch(function () {});
  }
  function soon() { clearTimeout(timer); timer = setTimeout(apply, 300); }
  if (document.readyState !== 'loading') apply(); else document.addEventListener('DOMContentLoaded', apply);
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
})();
